import log, { getBaseOrigin } from "@fxid/shared";

import OpenApiClient from "../OpenApiClient";

/**
 * Асинхронно получает URL для магазина игры.
 * Если требуется, создает временный токен для бесшовного перехода.
 * @param game - Системное имя игры.
 * @param redirectWithTempToken - Нужно ли создавать временный токен.
 * @returns {Promise<URL>} - Сгенерированный URL.
 */
export const getGameStoreUrl = async (game: string, redirectWithTempToken: boolean): Promise<URL> => {
	const baseOrigin = getBaseOrigin();
	log.debug("getGameStoreUrl: baseOrigin =", baseOrigin);

	if (redirectWithTempToken) {
		const { TempToken } = await OpenApiClient.Auth.fxIdWebFeaturesAuthCreateTempTokenEndpoint({
			RedirectUri: `/Store/${game}`
		});
		log.debug("getGameStoreUrl: creating URL with path=/LoginWithTempToken, baseOrigin=", baseOrigin);
		const url = new URL(`/LoginWithTempToken`, baseOrigin);
		url.searchParams.append("token", TempToken);
		log.info(`Generated temp token store URL: ${url}`);
		return url;
	}

	log.debug(`getGameStoreUrl: creating URL with path=Store/${game}, baseOrigin=`, baseOrigin);
	const url = new URL(`Store/${game}`, baseOrigin);
	log.info(`Generated direct store URL: ${url}`);
	return url;
};
